import { AppHomeComponent } from './basics/home/home.component';

export const routes = [
    {
        path: '',
        component: AppHomeComponent
    },
    {
        path: 'games',
        loadChildren: () => import('./games/games.routes').then(config => config.routes),
    },
    {
        path: 'tools',
        loadChildren: () => import('./tools/tools.routes').then(config => config.routes),
    },
    {
        path: '**',
        component: AppHomeComponent
    }
];